// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d452c9f0","732":"bbb2810d","977":"825d3851"}[chunkId] + ".chunk.js";
};